import { CreateEnteriesRequest, GetEnteriesByIdRequest, GetEnteriesRequest, ImportRunnersRequest, UpdateEnteriesRequest, UpdateEnteryStatusRequest } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CreateEnteryResponse, GetEnteriesResponse, GetEnteryByIdResponse, UpdateEnteryResponse } from "src/app/core/interfaces/runnerAdmin.interface";

export const enteriesActions = createActionGroup({
    source: 'Enteries',
    events: {
        ['Load enteries']: props<{ payload: GetEnteriesRequest, eventId: string }>(),
        ['Load enteries success']: props<GetEnteriesResponse>(),
        ['Load enteries failed']: props<GetEnteriesResponse>(),

        ['Load entery by id']: props<{ payload: GetEnteriesByIdRequest, eventId: string }>(),
        ['Load entery by id success']: props<GetEnteryByIdResponse>(),
        ['Load entery by id failed']: props<GetEnteryByIdResponse>(),

        ['Create enteries']: props<{ payload: CreateEnteriesRequest, eventId: string }>(),
        ['Create enteries success']: props<CreateEnteryResponse>(),
        ['Create enteries failed']: props<CreateEnteryResponse>(),

        ['Update enteries']: props<{ payload: UpdateEnteriesRequest, eventId: string, id: string }>(),
        ['Update enteries success']: props<UpdateEnteryResponse>(),
        ['Update enteries failed']: props<UpdateEnteryResponse>(),

        ['Import enteries']: props<{ payload: ImportRunnersRequest, eventId: string }>(),
        ['Import enteries success']: props<UpdateEnteryResponse>(),
        ['Import enteries failed']: props<UpdateEnteryResponse>(),

        ['Update entery status']: props<{ payload: UpdateEnteryStatusRequest, eventId: string, id: string }>(),
        ['Update entery status success']: props<UpdateEnteryResponse>(),
        ['Update entery status failed']: props<UpdateEnteryResponse>(),

        ['Reset selected runner']: emptyProps()

        // ['Delete entery by Id']: props<{eventId: string}>(),
        // ['Delete entery by Id success']: props<CreateEnteryResponse>(),
        // ['Delete entery by Id failed']: props<CreateEnteryResponse>(),

    }
})